import type { ChartDataPoint } from "./type";
import forexGraficData from "../../../data/forexGraficLineData.json";

export class ForexChartService {
  async getForexChartData(
    clientId: number, 
    buttonType: number, 
    dateRange?: { startDate?: number; endDate?: number }
  ): Promise<{ data: ChartDataPoint[] }> {
    let filteredData = forexGraficData.data.filter(
      (item: ChartDataPoint) => 
        item.clientId === clientId && item.range.id === buttonType
    );

    if (dateRange && (dateRange.startDate || dateRange.endDate)) {
      filteredData = filteredData.map(item => ({
        ...item,
        data: item.data.filter(dataPoint => {
          const date = dataPoint.date;
          const afterStart = !dateRange.startDate || date >= dateRange.startDate;
          const beforeEnd = !dateRange.endDate || date <= dateRange.endDate;
          return afterStart && beforeEnd;
        })
      })).filter(item => item.data.length > 0);
    }

    return { data: filteredData };
  }
}
